import { Box, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import "./style.scss";
import Logo from "../../assets/images/logo.png";
import ManulifeLogo from "../../assets/images/manulife.svg";
import ManulifeLogoMB from "../../assets/images/manulife-white.svg";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import NavMobile from "./NavMobile";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  const handleOpenMenu = () => {
    const elmMenuMB = document.getElementById("nav-mb")
    if(!elmMenuMB) return
    if(isOpenMenu) {
      elmMenuMB.style.visibility = "hidden"
      elmMenuMB.style.transform = "translate3d(100vw, 0, 0)"
      elmMenuMB.style.transition = ".3s"
    } else {
      elmMenuMB.style.visibility = "visible"
      elmMenuMB.style.transform = "translate3d(0,0,0)"
      elmMenuMB.style.transition = ".3s"
    }
    setIsOpenMenu(!isOpenMenu)
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 1);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`site-header ${isScrolled ? "scrolled" : ""}`}>
      <nav className="main-nav">
        {/* <NavMobile onClickNav={handleOpenMenu} isOpen={isOpenMenu} /> */}
        <div className="container">
          <div className="nav-left">
            <a href="https://www.manulife.com.vn/" className="navigation-logo">
              <img src={Logo} alt="Manulife Logo" />
            </a>
            <div className="header-logo">
              <img src={ManulifeLogo} className="web" alt="Manulife Logo" />
            </div>
            <div className="header-logo-mb">
              <img src={ManulifeLogoMB} className="web" alt="Manulife Logo" />
            </div>
          </div>
          {/* <div className="nav-content">
            <div className="nav-actions">
              <a href="#" className="login-btn">
                Đăng nhập Manulife Vietnam
              </a>
            </div>
            <div className="nav-actions-mb">
              <PersonIcon
                sx={{
                  fontSize: "26px",
                  color: "#ffffff",
                }}
              />
              <Box
                onClick={handleOpenMenu}
              >
                {isOpenMenu ? (
                  <CloseIcon
                    sx={{
                      fontSize: "26px",
                      color: "#ffffff",
                    }}
                  />
                ) : (
                  <MenuIcon
                    sx={{
                      fontSize: "26px",
                      color: "#ffffff",
                    }}
                  />
                )}
              </Box>
            </div>
          </div> */}
        </div>
      </nav>
    </header>
  );
}
